import Skeleton from "@/components/atoms/Skeleton";
import { ProductDetailsSkeleton } from "@/components/molecules/ProductDetails/DetailSkeleton";
import styles from "./index.module.css";

export const PDPCardSkeleton = () => {
  return <Skeleton height="300px" />;
};

export default function PdpSkeleton() {
  return (
    <div className="pdp-page">
      <div className="pdp-container" data-layout="section">
        <div className="pdp-gallery">
          <div className={styles.gallery}>
            <div className={styles.galleryThumbs}>
              <Skeleton height="" className={styles.galleryThumb} />
              <Skeleton height="" className={styles.galleryThumb} />
              <Skeleton height="" className={styles.galleryThumb} />
              <Skeleton height="" className={styles.galleryThumb} />
            </div>
            <Skeleton height="" className={styles.galleryImage} />
          </div>
        </div>
        <div className="pdp-details">
          <ProductDetailsSkeleton />
          <PDPCardSkeleton />
        </div>
      </div>
    </div>
  );
}
